import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import styles from './index.scss';
import properties from '../../../../modules/ajio-util/properties';
import ImageSlider from '../../../molecules/ImageSlider';
import { getCurrentStore } from '../../../selectors/metaData';
import { FLEEK_STORE } from '../../../../constants/constant';

const cx = classNames.bind(styles);
const imgPath = `${properties.getProperty('assetUrl')}/static`;

const ReviewSinglePhotoCard = props => {
  const { modalData, productDetails = {}, currentStore = '' } = props;

  const isFleek = currentStore === FLEEK_STORE;
  if (Object.keys(modalData).length === 0) {
    return null;
  }

  const {
    reviewData,
    reviewsCollection,
    loop = false,
    clickIndex = 0,
    arrowEnabled = false,
    fromCustomerGridModal = false
  } = modalData;
  const firstChildRef = useRef(null);
  const [firstChildHeight, setFirstChildHeight] = useState(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState(clickIndex);
  const [reviewsObj, setReviewsOBj] = useState(reviewData);
  const [backButton, setBackClick] = useState(false);

  const { imageMap, reviewerName, createdDate, rating, reviewText } = reviewsObj;
  const { thumbnail } = imageMap;
  const imageArray = thumbnail.length > 0 && thumbnail.map(imageObject => imageObject.imageUrl);

  const event = new Date(Number(createdDate));
  const options = { day: 'numeric', month: 'short', year: 'numeric' };
  const formattedDate = event.toLocaleDateString('en-IN', options);

  useEffect(() => {
    if (arrowEnabled) {
      let currentReviewdId = reviewsObj.reviewId;
      let nextReview = reviewsCollection.findIndex(e => {
        return e.reviewId === currentReviewdId;
      });
      if (!backButton && selectedImageIndex + 1 === imageArray.length + 1) {
        if (nextReview + 1 === reviewsCollection.length) {
          updateSelectedImageIndex(0);
          setReviewsOBj(reviewsCollection[0]);
        } else {
          updateSelectedImageIndex(0);
          setReviewsOBj(reviewsCollection[nextReview + 1]);
        }
      } else if (backButton && selectedImageIndex <= 0) {
        if (nextReview === 0) {
          let reviewObject = reviewsCollection[reviewsCollection.length - 1];
          let noOfImages = reviewObject?.imageMap?.thumbnail.length;
          updateSelectedImageIndex(noOfImages - 1);
          setReviewsOBj(reviewObject);
        } else {
          let reviewObject = reviewsCollection[nextReview - 1];
          let noOfImages = reviewObject?.imageMap?.thumbnail.length;
          updateSelectedImageIndex(noOfImages - 1);
          setReviewsOBj(reviewObject);
        }
      }
    }
  }, [selectedImageIndex]);

  const updateSelectedImageIndex = (currentIndex: number) => {
    setSelectedImageIndex(currentIndex);
  };

  const updateBackButtonClick = val => {
    setBackClick(val);
  };
  useEffect(() => {
    if (firstChildRef) {
      const calcHeight = firstChildRef?.current?.offsetHeight;
      setFirstChildHeight(calcHeight);
    }
  }, []);

  return (
    <>
      <div ref={firstChildRef} className={cx('single-photo-modal-msite')}>
        <div className={cx('single-photo-modal-container')}>
          <div className={cx('single-photo-modal-top-msite')}>
            <div className={cx('single-photo-modal-name-container')}>
              <p className={cx('heading', 'reviewer-name', isFleek && 'fleek-heading')}>
                {reviewerName}
              </p>
              <p className={cx('heading', isFleek && 'fleek-heading')}>| {formattedDate}</p>
            </div>
          </div>
          <div className={cx('single-photo-modal-bottom-msite')}>
            <div
              className={cx(
                'reviews-details-ratings-box',
                rating < 3 ? 'reviews-details-ratings-box-red' : 'reviews-details-ratings-box-green'
              )}
            >
              <span
                className={cx(
                  'reviews-details-rating-number',
                  isFleek && 'reviews-details-rating-fleek-number'
                )}
              >
                {rating}
              </span>
              <img
                className={cx('reviews-details-rating-img')}
                src={`${imgPath}${
                  isFleek ? '/img/fleek-rating-black-star.svg' : '/img/rating-star.svg'
                }`}
                alt="Star icon"
                onError={e => (e.target.src = '/img/rating-star.svg')}
              />
            </div>
            <p className={cx('single-photo-modal-review-text', isFleek && 'fleek-heading')}>
              {reviewText}
            </p>
          </div>
          <div className={cx('single-photo-modal-imageCount')}>
            <p className={cx('single-photo-modal-imageCount-number', isFleek && 'fleek-heading')}>
              {selectedImageIndex + 1} of {imageArray.length}
            </p>
          </div>
        </div>
      </div>
      <div
        style={{ height: `calc(74vh - ${firstChildHeight}px)` }}
        className={cx('image-slider-container-msite')}
      >
        <ImageSlider
          currentIndex={selectedImageIndex}
          updateSelectedImageIndex={updateSelectedImageIndex}
          backwardButtonClick={updateBackButtonClick}
          productDetails={productDetails}
          pageName="PDP"
          pageType="PDP"
          isMobile
          imageArray={imageArray}
          fromCustomerGridModal={fromCustomerGridModal}
          loop={loop}
          isFleek={isFleek}
        />
      </div>
    </>
  );
};

const mapStateToProps = (state, ownProps) => {
  const modals = state ? state.modals : {};
  const reviewModal = modals?.['reviews-single-photo'] || {};
  const modalData = reviewModal.state || {};
  let currentStore = getCurrentStore(state);
  return {
    ...ownProps,
    modalData,
    currentStore
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(ReviewSinglePhotoCard);
